module.exports = __webpack_public_path__ + "img/back lapped zipper length.bfa9fb56.png";